import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, XCircle } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import "./Logout.css"; // ✅ new stylesheet for mobile responsiveness

const Logout: React.FC = () => {
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const { dark } = useTheme();

  const bgClass = dark ? "bg-dark text-light" : "bg-light text-dark";
  const cardClass = dark ? "bg-secondary text-light" : "bg-white text-dark";

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("id");
    localStorage.removeItem("username");
    localStorage.removeItem("role");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("theme");
    navigate("/login", { replace: true });
    window.location.reload();
  };

  return (
    <div
      className={`logout-container d-flex flex-column justify-content-center align-items-center vh-100 position-relative ${bgClass}`}
    >
      {/* Overlay */}
      {showConfirm && (
        <div
          className="logout-overlay position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundColor: dark ? "rgba(0,0,0,0.6)" : "rgba(255,255,255,0.6)",
          }}
        ></div>
      )}

      {/* Confirmation Modal */}
      {showConfirm && (
        <div
          className={`logout-modal card shadow-lg border-3 text-center position-absolute ${cardClass}`}
        >
          <div className="p-4">
            <XCircle size={50} className="text-danger mx-auto mb-3" />
            <h5 className="fw-bold mb-3">Are you sure you want to log out?</h5>
            <p className="text-muted mb-4">
              You’ll need to sign in again to access your dashboard.
            </p>
            <div className="d-flex justify-content-center flex-wrap gap-3">
              <button
                className="btn btn-outline-secondary px-4 fw-semibold"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger px-4 fw-semibold"
                onClick={handleLogout}
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Default View */}
      {!showConfirm && (
        <div className="text-center logout-main">
          <h3 className="fw-bold mb-4">Logout</h3>
          <p className="fw-bold mb-4">
            You are currently logged in. Click below to log out.
          </p>
          <button
            className="btn btn-danger d-flex align-items-center justify-content-center px-4 py-2 fw-semibold rounded-3 shadow-sm mx-auto"
            onClick={() => setShowConfirm(true)}
          >
            <LogOut size={18} className="me-2" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default Logout;
